'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _products = require('ifeis-isomorphic/lib/redux/selectors/products');

var _paths = require('ifeis-isomorphic/lib/redux/actions/feiseanna/paths');

var _ifeisIsomorphic = require('ifeis-isomorphic');

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var isRegisterable = function isRegisterable(person) {
  return person.get('dob') && person.get('school');
};

exports.default = function (feis, account_id, user_id) {
  return function (state) {
    var feis_id = feis.get('id');
    var cartPath = ['feiseanna', 'carts', feis_id, 'accounts', account_id];
    var pathToPersonEvents = function pathToPersonEvents(person_id) {
      return ['events', 'persons', person_id, 'feiseanna', feis_id, 'eligible'];
    };

    var registerablePersons = (0, _immutable.List)();

    var cart = state.getIn(cartPath) || (0, _immutable.Map)();
    var events = state.getIn(['events', 'one']) || (0, _immutable.Map)();
    var account = state.getIn(['persons', 'one', account_id]) || (0, _immutable.Map)();
    var currentUser = state.getIn(['persons', 'one', user_id]) || (0, _immutable.Map)();
    var dependents = state.getIn(['accounts', account_id, 'dependents']) || (0, _immutable.List)();
    var cartItems = state.getIn([].concat(cartPath, ['debits', 'items'])) || (0, _immutable.List)();
    var payments = state.getIn([].concat(cartPath, ['credits', 'items'])) || (0, _immutable.List)();
    var groupFees = (0, _paths.getGroupFeesForFeis)(state, feis.get('id'));

    if (groupFees.get('loading')) {
      return {
        groupFeesLoading: true
      };
    }

    if (!account.get('loading') && !dependents.get('loading')) {
      registerablePersons = registerablePersons.merge(dependents.filter(isRegisterable));

      if (isRegisterable(account)) {
        registerablePersons = registerablePersons.unshift(account);
      }
    }

    var eventsForPerson = registerablePersons.reduce(function (map, person) {
      var evs = state.getIn(pathToPersonEvents(person.get('id')));

      if (evs && evs.getIn('loading')) {
        return map.set(person.get('id'), evs);
      }

      if (!evs) {
        return map.set(person.get('id'), (0, _immutable.List)());
      }

      return map.set(person.get('id'), evs.map(function (eid) {
        return events.get(eid);
      }));
    }, (0, _immutable.Map)());

    var purchases = cartItems.filter(function (v) {
      return v.get('type') === 'P';
    }).sort(function (p1, p2) {
      return p1.get('product') - p2.get('product');
    }).reduce(function (groupedPurchases, p) {
      if (groupedPurchases.size === 0) {
        return (0, _immutable.List)([p]);
      } else {
        var idxOfDupObj = groupedPurchases.findIndex(function (g) {
          return g.get('product') === p.get('product');
        });
        if (idxOfDupObj !== -1) {
          var updatedObj = groupedPurchases.get(idxOfDupObj).set('qty', groupedPurchases.get(idxOfDupObj).get('qty') + 1);
          return groupedPurchases.remove(idxOfDupObj).concat([updatedObj]);
        } else {
          return (0, _immutable.List)([].concat(_toConsumableArray(groupedPurchases), [p]));
        }
      }
    }, (0, _immutable.List)());

    var estimatedCreditCardFee = 0;

    if (cart.get('balance') > 0) {
      estimatedCreditCardFee = (0, _ifeisIsomorphic.calculateCreditCardFee)(cart.get('balance'), feis.get('credit_card_fee').toJS());
    }

    var assessments = cartItems.filter(function (v) {
      return v.get('type') === 'F';
    });

    if (estimatedCreditCardFee > 0) {
      assessments = assessments.unshift((0, _immutable.fromJS)({ amount: estimatedCreditCardFee, description: 'Credit Card Fee' }));
    }

    var eventDebits = cartItems.filter(function (v) {
      return v.get('type') === 'R';
    });

    var purchasesTotal = purchases.reduce(function (total, item) {
      return total + item.get('amount');
    }, 0);
    var assessmentsTotal = assessments.reduce(function (total, item) {
      return total + item.get('amount');
    }, 0);
    var paymentsTotal = payments.reduce(function (total, item) {
      return total + item.get('amount');
    }, 0);

    var persons_reged = eventDebits.map(function (v) {
      return v.get('person');
    }).toSet();

    var regWithNoGroupFeesSubjectToMaxTotal = eventDebits.filter(function (v) {
      return !v.get('exclude_from_max') && !v.get('groupFeeId');
    }).reduce(function (total, item) {
      return total + item.get('amount');
    }, 0);

    var regWithNoGroupFeesNotSubjectToMaxTotal = eventDebits.filter(function (v) {
      return v.get('exclude_from_max') && !v.get('groupFeeId');
    }).reduce(function (total, item) {
      return total + item.get('amount');
    }, 0);

    var registrationsByGroupFeesForTotal = eventDebits.filter(function (item) {
      return item.get('groupFeeId');
    }).reduce(function (map, item) {
      var person = item.get('person');
      var groupFee = item.get('groupFeeId');
      var regs = (map.getIn([person, groupFee]) || (0, _immutable.List)()).push(item);
      return map.setIn([person, groupFee], regs);
    }, (0, _immutable.Map)());

    var regWithGroupFeesSubjectToMaxTotal = persons_reged.reduce(function (total, person) {
      var groupFeesList = Object.keys((registrationsByGroupFeesForTotal.get(person) || (0, _immutable.List)()).toJS() || []);
      return total + groupFeesList.reduce(function (t, f) {
        var eventWithGroupFee = registrationsByGroupFeesForTotal.getIn([person, f]).filter(function (e) {
          return !e.get('exclude_from_max');
        }).get(0) || (0, _immutable.Map)();
        return t + (eventWithGroupFee.get('amount') || 0);
      }, 0);
    }, 0);

    var regWithGroupFeesNotSubjectToMaxTotal = persons_reged.reduce(function (total, person) {
      var groupFeesList = Object.keys((registrationsByGroupFeesForTotal.get(person) || (0, _immutable.List)()).toJS() || []);
      return total + groupFeesList.reduce(function (t, f) {
        var eventWithGroupFee = registrationsByGroupFeesForTotal.getIn([person, f]).filter(function (e) {
          return e.get('exclude_from_max');
        }).get(0) || (0, _immutable.Map)();
        return t + (eventWithGroupFee.get('amount') || 0);
      }, 0);
    }, 0);

    var regSubjectToMaxTotal = regWithGroupFeesSubjectToMaxTotal + regWithNoGroupFeesSubjectToMaxTotal;

    var regNotSubjectToMaxTotal = regWithGroupFeesNotSubjectToMaxTotal + regWithNoGroupFeesNotSubjectToMaxTotal;

    var acct_max = feis.get('acct_max');
    var acctMaxMet = regSubjectToMaxTotal > acct_max;

    // if we've met the max, add an asterisk to the competitions subject to it.
    if (acctMaxMet) {
      eventDebits = eventDebits.map(function (ev) {
        if (ev.get('exclude_from_max')) {
          return ev;
        }

        return ev.set('description', ev.get('description') + '*');
      });
    }

    var registrationsTotal = regNotSubjectToMaxTotal + (acctMaxMet ? acct_max : regSubjectToMaxTotal);

    var registrationsByNoGroupFees = eventDebits.filter(function (item) {
      return !item.get('groupFeeId');
    }).reduce(function (map, item) {
      var person = item.get('person');
      var regs = (map.get(person) || (0, _immutable.List)()).push(item);

      return map.set(person, regs);
    }, (0, _immutable.Map)());

    var registrationsByGroupFees = eventDebits.filter(function (item) {
      return item.get('groupFeeId');
    }).reduce(function (map, item) {
      var person = item.get('person');
      var groupFee = item.get('groupFeeId');
      var regs = (map.getIn([person, groupFee]) || (0, _immutable.List)()).push(item);
      return map.setIn([person, groupFee], regs);
    }, (0, _immutable.Map)());

    var personRegistrationTotals = persons_reged.reduce(function (map, person) {
      var groupFeesList = Object.keys((registrationsByGroupFees.get(person) || (0, _immutable.List)()).toJS() || []);
      var groupFeesTotal = groupFeesList.reduce(function (total, f) {
        var groupFeesForEvent = groupFees.find(function (g) {
          return g.get('id') === f;
        });
        return total + ((groupFeesForEvent || {}).amount || 0);
      }, 0);

      var total = (registrationsByNoGroupFees.get(person) || (0, _immutable.List)()).reduce(function (t, i) {
        return t + i.get('amount');
      }, 0) + groupFeesTotal;

      return map.set(person, total);
    }, (0, _immutable.Map)());

    var balance = (cart && cart.get('balance') || 0) + estimatedCreditCardFee || 0;

    var paidPrelimDancersCount = feis.get('paid_prelim_dancers_count');
    var paidGradeDancersCount = feis.get('paid_grades_dancers_count');
    var paidChampDancersCount = feis.get('paid_champ_dancers_count');
    var prelimsCapReachedMessage = paidPrelimDancersCount && paidPrelimDancersCount >= feis.get('prelims_events_cap') && 'Prelim Champion competitions have reached their cap';
    var openChampCapReachedMessage = paidChampDancersCount && paidChampDancersCount >= feis.get('open_events_cap') && 'Open Champion competitions have reached the cap';
    var champsCapReachedMessage = paidPrelimDancersCount && paidChampDancersCount && paidPrelimDancersCount >= feis.get('prelims_events_cap') && paidChampDancersCount >= feis.get('open_events_cap') && 'Champion competitions have reached their cap';
    var gradesCapReachedMessage = paidGradeDancersCount && paidGradeDancersCount >= feis.get('grades_events_cap') && 'Grade competitions have reached their cap';

    if (state.getIn(['feiseanna', 'products', feis_id, 'loading'])) {
      return {
        currentUser: currentUser,
        account: account,
        dependents: dependents,
        registerablePersons: registerablePersons,
        payments: payments,
        cart: cart,
        events: events,
        eventsForPerson: eventsForPerson,
        assessments: assessments,
        purchases: purchases,
        persons_reged: persons_reged,
        personRegistrationTotals: personRegistrationTotals,
        regNotSubjectToMaxTotal: regNotSubjectToMaxTotal,
        regSubjectToMaxTotal: regSubjectToMaxTotal,
        registrationsTotal: registrationsTotal,
        acctMaxMet: acctMaxMet,
        purchasesTotal: purchasesTotal,
        paymentsTotal: paymentsTotal,
        assessmentsTotal: assessmentsTotal,
        products: (0, _immutable.fromJS)({ loading: true }),
        balance: balance,
        estimatedCreditCardFee: estimatedCreditCardFee,
        registrationsByNoGroupFees: registrationsByNoGroupFees,
        registrationsByGroupFees: registrationsByGroupFees,
        groupFees: groupFees,
        groupFeesLoading: false,
        paidPrelimDancersCount: paidPrelimDancersCount,
        paidGradeDancersCount: paidGradeDancersCount,
        paidChampDancersCount: paidChampDancersCount,
        prelimsCapReachedMessage: prelimsCapReachedMessage,
        openChampCapReachedMessage: openChampCapReachedMessage,
        champsCapReachedMessage: champsCapReachedMessage,
        gradesCapReachedMessage: gradesCapReachedMessage
      };
    }

    var productsAvailable = false;
    var products = (0, _products.productsState)(state, feis_id).map(function (product_id) {
      if (state.getIn(['products', product_id, 'images', 'loading']) || state.getIn(['products', 'one', 'loading'])) {
        return (0, _immutable.fromJS)({ loading: true });
      }
      var p = (0, _products.getOneProduct)(state, product_id);
      var retirementMoment = (0, _momentTimezone2.default)(p.get('retirementDate')).tz(feis.get('tz')).endOf('day');
      var currentMoment = (0, _momentTimezone2.default)(new Date()).tz(feis.get('tz'));
      if (retirementMoment > currentMoment) {
        productsAvailable = true;
      }
      var imagesForProduct = (0, _products.getImagesList)(state, p.get('id')).map(function (image_id) {
        return (0, _products.getOneImage)(state, image_id);
      }) || (0, _immutable.List)();
      return p.setIn(['images'], imagesForProduct);
    });

    return {
      currentUser: currentUser,
      account: account,
      dependents: dependents,
      registerablePersons: registerablePersons,
      payments: payments,
      cart: cart,
      events: events,
      eventsForPerson: eventsForPerson,
      assessments: assessments,
      purchases: purchases,
      persons_reged: persons_reged,
      personRegistrationTotals: personRegistrationTotals,
      regNotSubjectToMaxTotal: regNotSubjectToMaxTotal,
      regSubjectToMaxTotal: regSubjectToMaxTotal,
      registrationsTotal: registrationsTotal,
      acctMaxMet: acctMaxMet,
      purchasesTotal: purchasesTotal,
      paymentsTotal: paymentsTotal,
      assessmentsTotal: assessmentsTotal,
      products: products,
      productsAvailable: productsAvailable,
      balance: balance,
      estimatedCreditCardFee: estimatedCreditCardFee,
      registrationsByNoGroupFees: registrationsByNoGroupFees,
      registrationsByGroupFees: registrationsByGroupFees,
      groupFees: groupFees,
      groupFeesLoading: false,
      paidPrelimDancersCount: paidPrelimDancersCount,
      paidGradeDancersCount: paidGradeDancersCount,
      paidChampDancersCount: paidChampDancersCount,
      prelimsCapReachedMessage: prelimsCapReachedMessage,
      openChampCapReachedMessage: openChampCapReachedMessage,
      champsCapReachedMessage: champsCapReachedMessage,
      gradesCapReachedMessage: gradesCapReachedMessage
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/register/mapStateToController.js
// module id = 589
// module chunks = 0